import "./index.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import Pages from "./pages/Index";
import { useEffect, useState } from "react";
import GoogleOneTapLogin from "react-google-one-tap-login";
import Loader from "./components/Loader";
import { disableSplashScreen } from "./api/enkripsi";
import Footer from "./components/Footer";

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [flagGoogle, setFlagGoogle] = useState(false);
  const location = useLocation();

  useEffect(() => {
    disableSplashScreen();
    setIsLoading(false);
    if (localStorage.getItem("name") == null) {
      setFlagGoogle(true);
    }
  }, []);

  const firstSegment = "/" + location.pathname.split("/")[1];

  const hexToRgb = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  };

  if (isLoading) return <Loader />;

  return (
    <>
      {flagGoogle && (
        <GoogleOneTapLogin
          onError={(error) => console.log(error)}
          onSuccess={(response) => {
            localStorage.setItem("email", response.email);
            localStorage.setItem("name", response.name);
          }}
          googleAccountConfigs={{
            client_id:
              "301415234328-98f5ceieu7b9j60g62usjculjcb4tec2.apps.googleusercontent.com",
          }}
        />
      )}

      <Pages />

      {firstSegment !== "/detail" &&
        firstSegment !== "/bacaBuku" &&
        firstSegment !== "/audioplayer" &&
        firstSegment !== "/games" && <Footer />}
    </>
  );
};

// Wrapper untuk menyisipkan <BrowserRouter>
const AppWrapper = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default AppWrapper;
